export default __webpack_public_path__ + "static/B0070-d67811cd9ecf3fcc0b20fe97489ea77a.png";